import React from 'react';

const Star = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="block">
    <path d="M12 2l2.9 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 7.1-1.01L12 2z" />
  </svg>
);

const StarRating = ({ count = 5, label, className }) => (
  <span className={`inline-flex gap-0.5 text-amber ${className || ''}`} role="img" aria-label={label || `${count} out of 5 stars`}>
    {Array.from({ length: count }).map((_, i) => <Star key={i} />)}
  </span>
);

export default StarRating;
